import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LimitPopupService {
  private isLimitReached$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  get limitReached$() {
    return this.isLimitReached$.asObservable();
  }

  showLimitPopup() {
    this.isLimitReached$.next(true);
  }

  hideLimitPopup() {
    this.isLimitReached$.next(false);
  }

  get isLimitReached() {
    return this.isLimitReached$.value;
  }
}
